/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType
} from "axios"
import axios from "axios"

export type QueryParamsType = Record<string | number, any>

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType
  /** request body */
  body?: unknown
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void
  secure?: boolean
  format?: ResponseType
}

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain"
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"]
  private secure?: boolean
  private format?: ResponseType

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || "" })
    this.secure = secure
    this.format = format
    this.securityWorker = securityWorker
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method)

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {})
      }
    }
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem)
    } else {
      return `${formItem}`
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key]
      const propertyContent: any[] = property instanceof Array ? property : [property]

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem))
      }

      return formData
    }, new FormData())
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const responseFormat = format || this.format || undefined

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>)
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
      body = JSON.stringify(body)
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {})
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path
    })
  }
}

/**
 * @title Lovers live forever API
 * @version 0.0.1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  ping = {
    /**
     * No description
     *
     * @tags robot
     * @name PingList
     * @request GET:/ping
     */
    pingList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          pong: boolean
        },
        any
      >({
        path: `/ping`,
        method: "GET",
        format: "json",
        ...params
      })
  }
  robotsTxt = {
    /**
     * No description
     *
     * @tags robot
     * @name RobotsTxtList
     * @request GET:/robots.txt
     */
    robotsTxtList: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success: boolean
          /** @example "User-agent: *" */
          data: string
        },
        any
      >({
        path: `/robots.txt`,
        method: "GET",
        format: "json",
        ...params
      })
  }
  user = {
    /**
     * No description
     *
     * @name CreateUser
     * @request POST:/user
     */
    createUser: (
      data: {
        /** @example "matzie" */
        name: string
        /**
         * @format email
         * @example "example@example.com"
         */
        email: string
        /**
         * @minLength 6
         * @example "hunter2"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "exampleToken" */
          token: string
          /** @example "exampleRefreshToken" */
          refreshToken: string
          user: {
            /** @example "exampleId" */
            id: string
            /** @example "matzie" */
            name: string
            /** @example "example@example.com" */
            email: string
            profileImageUrl?: string
            /** @example "2024-01-01T00:00:00.000Z" */
            createdAt: string
            /** @example true */
            emailVerified: boolean
            /** @example false */
            blocked: boolean
          }
        },
        {
          errorCode:
            | "GENERAL_ERROR"
            | "INVALID_DATA"
            | "EMAIL_ALREADY_IN_USE"
            | "WRONG_PASSWORD"
            | "NOT_FOUND"
            | "USER_NOT_FOUND"
            | "FORBIDDEN"
            | "TOKEN_LIMIT_REACHED"
            | "USER_ALREADY_EXISTS"
            | "INVALID_TOKEN"
            | "TIME_CAPSULE_NOT_FOUND"
            | "TIME_CAPSULE_ALREADY_OPENED"
            | "TIME_CAPSULE_DOES_NOT_OPEN_YET"
            | "PROFILE_IMAGE_FILE_TOO_LARGE"
            | "INVALID_PROFILE_IMAGE"
            | "NOT_ALLOWED_TO_UPDATE_TIME_CAPSULE"
            | "NOT_ALLOWED_TO_DELETE_TIME_CAPSULE"
            | "FAILED_TO_RESPOND_TO_INVITE"
          errorMessage: string
          httpStatus: number
          ok: false
        }
      >({
        path: `/user`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  }
  login = {
    /**
     * No description
     *
     * @name LoginUser
     * @request POST:/login
     */
    loginUser: (
      data: {
        /**
         * @format email
         * @example "example@example.com"
         */
        email: string
        /**
         * @minLength 6
         * @example "hunter2"
         */
        password: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "exampleToken" */
          token: string
          /** @example "exampleRefreshToken" */
          refreshToken: string
          user: {
            /** @example "exampleId" */
            id: string
            /** @example "matzie" */
            name: string
            /** @example "example@example.com" */
            email: string
            profileImageUrl?: string
            /** @example "2024-01-01T00:00:00.000Z" */
            createdAt: string
            /** @example true */
            emailVerified: boolean
            /** @example false */
            blocked: boolean
          }
        },
        {
          errorCode:
            | "GENERAL_ERROR"
            | "INVALID_DATA"
            | "EMAIL_ALREADY_IN_USE"
            | "WRONG_PASSWORD"
            | "NOT_FOUND"
            | "USER_NOT_FOUND"
            | "FORBIDDEN"
            | "TOKEN_LIMIT_REACHED"
            | "USER_ALREADY_EXISTS"
            | "INVALID_TOKEN"
            | "TIME_CAPSULE_NOT_FOUND"
            | "TIME_CAPSULE_ALREADY_OPENED"
            | "TIME_CAPSULE_DOES_NOT_OPEN_YET"
            | "PROFILE_IMAGE_FILE_TOO_LARGE"
            | "INVALID_PROFILE_IMAGE"
            | "NOT_ALLOWED_TO_UPDATE_TIME_CAPSULE"
            | "NOT_ALLOWED_TO_DELETE_TIME_CAPSULE"
            | "FAILED_TO_RESPOND_TO_INVITE"
          errorMessage: string
          httpStatus: number
          ok: false
        }
      >({
        path: `/login`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  }
  logout = {
    /**
     * No description
     *
     * @name LogoutUser
     * @request POST:/logout
     * @secure
     */
    logoutUser: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          byebye: boolean
          /** @example true */
          willMissYou: boolean
        },
        any
      >({
        path: `/logout`,
        method: "POST",
        secure: true,
        format: "json",
        ...params
      })
  }
  self = {
    /**
     * No description
     *
     * @name GetSelf
     * @request GET:/self
     * @secure
     */
    getSelf: (params: RequestParams = {}) =>
      this.request<
        {
          user: {
            /** @example "exampleId" */
            id: string
            /** @example "matzie" */
            name: string
            /** @example "example@example.com" */
            email: string
            profileImageUrl?: string
            /** @example "2024-01-01T00:00:00.000Z" */
            createdAt: string
            /** @example true */
            emailVerified: boolean
            /** @example false */
            blocked: boolean
          }
        },
        any
      >({
        path: `/self`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name DeleteSelf
     * @request DELETE:/self
     * @secure
     */
    deleteSelf: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          willMissYou: boolean
        },
        any
      >({
        path: `/self`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name UpdateSelf
     * @request PUT:/self
     * @secure
     */
    updateSelf: (
      data: {
        /**
         * @minLength 1
         * @maxLength 50
         */
        name?: string
        /** @format binary */
        profileImage?: File
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          user: {
            id: string
            name: string
            email: string
            profileImageUrl?: string
            createdAt: string
            emailVerified: boolean
            blocked: boolean
          }
        },
        any
      >({
        path: `/self`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetSelfTimeCapsules
     * @request GET:/self/time-capsules
     * @secure
     */
    getSelfTimeCapsules: (params: RequestParams = {}) =>
      this.request<
        {
          timeCapsules: {
            /** @example "exampleId" */
            id: string
            /** @example "4 future" */
            name: string
            /** @example "4-future" */
            slug?: string
            /** @example "2030-01-01T00:00:00.000Z" */
            opensAt?: string
            /** @example "rec_1234" */
            creatorId: string
            /** @example "2024-01-01T00:00:00.000Z" */
            createdAt: string
          }[]
        },
        any
      >({
        path: `/self/time-capsules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetTimeCapsuleBySlug
     * @request GET:/self/time-capsules/{slug}
     * @secure
     */
    getTimeCapsuleBySlug: (slug: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example "exampleId" */
          id: string
          /** @example "4 future" */
          name: string
          /** @example "4-future" */
          slug?: string
          /** @example "2030-01-01T00:00:00.000Z" */
          opensAt?: string
          /** @example "matzie" */
          creatorName: string
          /** @example "2024-01-01T00:00:00.000Z" */
          createdAt: string
          /** @example [{"creatorName":"matzie","timestamp":"2024-01-01T00:00:00.000Z"}] */
          entries?: {
            /** @example "matzie" */
            creatorName: string
            /** @example "2024-01-01T00:00:00.000Z" */
            timestamp: string
          }[]
        },
        any
      >({
        path: `/self/time-capsules/${slug}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetSelfInvites
     * @request GET:/self/invites
     * @secure
     */
    getSelfInvites: (params: RequestParams = {}) =>
      this.request<
        {
          invites: {
            /** @example "123" */
            id: string
            /** @example "456" */
            timeCapsuleId: string
            /** @example "My time capsule" */
            timeCapsuleName: string
            /** @example "John Doe" */
            fromName?: string
          }[]
        },
        any
      >({
        path: `/self/invites`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name RespondToTimeCapsuleInvite
     * @request POST:/self/invites/{inviteId}/respond
     * @secure
     */
    respondToTimeCapsuleInvite: (
      inviteId: string,
      data: {
        /** @example true */
        isAccepting: boolean
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          accepted: boolean
          /** @example "123" */
          capsuleId: string
          /** @example "123" */
          inviteId: string
        },
        any
      >({
        path: `/self/invites/${inviteId}/respond`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name UpdateSelfPassword
     * @request PUT:/self/password
     * @secure
     */
    updateSelfPassword: (
      data: {
        /**
         * @minLength 6
         * @example "hunter3"
         */
        newPassword: string
        /**
         * @minLength 6
         * @example "hunter2"
         */
        currentPassword: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          updated: boolean
        },
        any
      >({
        path: `/self/password`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ListSelfSharedTimeCapsules
     * @request GET:/self/shared/time-capsules
     * @secure
     */
    listSelfSharedTimeCapsules: (params: RequestParams = {}) =>
      this.request<
        {
          timeCapsules: {
            /** @example "exampleId" */
            id: string
            /** @example "4 future" */
            name: string
            /** @example "4-future" */
            slug?: string
            /** @example "2030-01-01T00:00:00.000Z" */
            opensAt?: string
            /** @example "matzie" */
            creatorName: string
            /** @example "rec_1234" */
            creatorId: string
            /** @example "2024-01-01T00:00:00.000Z" */
            createdAt: string
          }[]
        },
        any
      >({
        path: `/self/shared/time-capsules`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetSharedTimeCapsuleBySlug
     * @request POST:/self/shared/time-capsules/{slug}
     * @secure
     */
    getSharedTimeCapsuleBySlug: (
      slug: string,
      data: {
        /** @example "rec_1234" */
        ownerId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "exampleId" */
          id: string
          /** @example "4 future" */
          name: string
          /** @example "4-future" */
          slug?: string
          /** @example "2030-01-01T00:00:00.000Z" */
          opensAt?: string
          /** @example "matzie" */
          creatorName: string
          /** @example "2024-01-01T00:00:00.000Z" */
          createdAt: string
          /** @example [{"creatorName":"matzie","timestamp":"2024-01-01T00:00:00.000Z"}] */
          entries?: {
            /** @example "matzie" */
            creatorName: string
            /** @example "2024-01-01T00:00:00.000Z" */
            timestamp: string
          }[]
        },
        any
      >({
        path: `/self/shared/time-capsules/${slug}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  }
  verifyEmail = {
    /**
     * No description
     *
     * @name VerifyEmail
     * @request POST:/verify-email
     */
    verifyEmail: (
      data: {
        /** @example "05e6b509faeba3ed7864921af886445d" */
        verificationCode: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          verified: boolean
        },
        any
      >({
        path: `/verify-email`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name ResendVerificationEmail
     * @request POST:/verify-email/resend
     * @secure
     */
    resendVerificationEmail: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          resent: boolean
        },
        any
      >({
        path: `/verify-email/resend`,
        method: "POST",
        secure: true,
        format: "json",
        ...params
      })
  }
  forgotPassword = {
    /**
     * No description
     *
     * @name SendForgotPasswordMail
     * @request POST:/forgot-password
     */
    sendForgotPasswordMail: (
      data: {
        /**
         * @format email
         * @example "example@example.com"
         */
        email: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          sent: boolean
        },
        any
      >({
        path: `/forgot-password`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name UpdatePassword
     * @request POST:/forgot-password/update
     */
    updatePassword: (
      data: {
        /**
         * @minLength 6
         * @example "hunter2"
         */
        newPassword: string
        /** @example "05e6b509faeba3ed7864921af886445d" */
        updateCode: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          updated: boolean
        },
        any
      >({
        path: `/forgot-password/update`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params
      })
  }
  refresh = {
    /**
     * No description
     *
     * @name RefreshTokens
     * @request GET:/refresh
     * @secure
     */
    refreshTokens: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "05e6b509faeba3ed7864921af886445d" */
          newToken: string
          /** @example "05e6b509faeba3ed7864921af886445d" */
          newRefreshToken: string
        },
        any
      >({
        path: `/refresh`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      })
  }
  matzie = {
    /**
     * No description
     *
     * @name Matzie
     * @request GET:/matzie
     */
    matzie: (params: RequestParams = {}) =>
      this.request<
        {
          /** @example "matzie" */
          hello: string
          /** @example "1.0.0" */
          version: string
        },
        any
      >({
        path: `/matzie`,
        method: "GET",
        format: "json",
        ...params
      })
  }
  timeCapsule = {
    /**
     * No description
     *
     * @name CreateTimeCapsule
     * @request POST:/time-capsule
     * @secure
     */
    createTimeCapsule: (
      data: {
        /** @example "4 future" */
        name: string
        /** @example "2030-01-01T00:00:00.000Z" */
        opensAt?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "exampleId" */
          id: string
          /** @example "slug" */
          slug: string
          /** @example "2030-01-01T00:00:00.000Z" */
          opensAt?: string
        },
        any
      >({
        path: `/time-capsule`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name CreateTimeCapsuleEntry
     * @request POST:/time-capsule/entry
     * @secure
     */
    createTimeCapsuleEntry: (
      data: {
        /** @example "Hello future, here is an entry" */
        text: string
        /** @example "exampleId" */
        timeCapsuleId: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example true */
          saved: boolean
        },
        any
      >({
        path: `/time-capsule/entry`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name CreateTimeCapsuleInvitations
     * @request POST:/time-capsule/:timeCapsuleId/invitations
     * @secure
     */
    createTimeCapsuleInvitations: (
      timeCapsuleId: string,
      data: {
        emails: string[]
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          invitations: {
            /** @example "exampleId" */
            id: string
            /** @example "example@example.com" */
            email: string
            /** @example "pending" */
            status: string
            /** @example "2021-01-01T00:00:00.000Z" */
            createdAt: string
          }[]
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}/invitations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetTimeCapsuleInvitations
     * @request GET:/time-capsule/:timeCapsuleId/invitations
     * @secure
     */
    getTimeCapsuleInvitations: (timeCapsuleId: string, params: RequestParams = {}) =>
      this.request<
        {
          invitations: {
            /** @example "exampleId" */
            id: string
            /** @example "example@example.com" */
            email: string
            /** @example "pending" */
            status: string
            /** @example "2021-01-01T00:00:00.000Z" */
            createdAt: string
          }[]
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}/invitations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name GetTimeCapsuleMembers
     * @request GET:/time-capsule/:timeCapsuleId/members
     * @secure
     */
    getTimeCapsuleMembers: (timeCapsuleId: string, params: RequestParams = {}) =>
      this.request<
        {
          members: {
            /** @example "rec_1234567890" */
            membershipId: string
            /** @example "exampleId" */
            id: string
            /** @example "example@example.com" */
            email: string
            /** @example "matzie" */
            name: string
            /** @example "2021-01-01T00:00:00.000Z" */
            memberSince: string
          }[]
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}/members`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name OpenTimeCapsule
     * @request GET:/time-capsule/open/{timeCapsuleId}
     * @secure
     */
    openTimeCapsule: (timeCapsuleId: string, params: RequestParams = {}) =>
      this.request<
        {
          timeCapsule: {
            /** @example "1212121" */
            id: string
            /** @example "My time capsule" */
            name: string
            /** @example "2021-12-12T12:12:12Z" */
            createdAt: string
            /** @example "2021-12-12T12:12:12Z" */
            openedAt?: string
            /** @example "matzie" */
            createdBy: string
          }
          entries: {
            /** @example "1337420" */
            id: string
            /** @example "Hello future, here is an entry" */
            text?: string
            /** @example "2021-12-12T12:12:12Z" */
            customEntryDate?: string
            /** @example "2021-12-12T12:12:12Z" */
            createdAt: string
            /** @example "matzie" */
            createdBy: string
            /** @example "https://profileimage.url" */
            creatorAvatarUrl?: string
          }[]
        },
        any
      >({
        path: `/time-capsule/open/${timeCapsuleId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name UpdateTimeCapsule
     * @request PUT:/time-capsule/{timeCapsuleId}
     * @secure
     */
    updateTimeCapsule: (
      timeCapsuleId: string,
      data: {
        /** @example "4 future" */
        name?: string
        /** @example "2030-01-01T00:00:00.000Z" */
        opensAt?: string
      },
      params: RequestParams = {}
    ) =>
      this.request<
        {
          /** @example "exampleId" */
          id: string
          /** @example "slug" */
          slug: string
          /** @example "2030-01-01T00:00:00.000Z" */
          opensAt?: string
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name DeleteTimeCapsule
     * @request DELETE:/time-capsule/{timeCapsuleId}
     * @secure
     */
    deleteTimeCapsule: (timeCapsuleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          deleted: boolean
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      }),

    /**
     * No description
     *
     * @name LeaveTimeCapsule
     * @request DELETE:/time-capsule/:timeCapsuleId/leave
     * @secure
     */
    leaveTimeCapsule: (timeCapsuleId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success: boolean
        },
        any
      >({
        path: `/time-capsule/${timeCapsuleId}/leave`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      })
  }
  invitations = {
    /**
     * No description
     *
     * @name DeleteInvitation
     * @request DELETE:/invitations/:invitationId
     * @secure
     */
    deleteInvitation: (invitationId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success: boolean
        },
        any
      >({
        path: `/invitations/${invitationId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      })
  }
  members = {
    /**
     * No description
     *
     * @name DeleteMember
     * @request DELETE:/members/:memberId
     * @secure
     */
    deleteMember: (memberId: string, params: RequestParams = {}) =>
      this.request<
        {
          /** @example true */
          success: boolean
        },
        any
      >({
        path: `/members/${memberId}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params
      })
  }
}
